import { render } from "./WhatsappBotRules.vue?vue&type=template&id=1db62e26"
import script from "./WhatsappBotRules.vue?vue&type=script&lang=js"
export * from "./WhatsappBotRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__